import React, { Fragment } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { BrowserUses } from '../../../Constant';
import { browserUses } from '../../../Data/Widgets/Chart/ChartData';

const BrowserUsesChart = () => {
  return (
    <Fragment>
      <Col sm='12' className='box-col-12'>
        <div className='donut-chart-widget'>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{BrowserUses}</H5>
            </CardHeader>
            <CardBody>
              <div id='chart-widget13'>
                <ReactApexChart options={browserUses.options} series={browserUses.series} height='500' type='candlestick' />
              </div>
            </CardBody>
          </Card>
        </div>
      </Col>
    </Fragment>
  );
};
export default BrowserUsesChart;
